

app.controller('CIF4-CTRL', function ($scope, $rootScope, $routeParams, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter, KTPCamService, SELFIECamService, deviceDetector) {

    $scope.allowedExt = ['.jpg', '.jpeg', '.bmp', '.png'];
    $scope.agree1 = false;
    $scope.agree2 = false;
    $scope.agree3 = false;

    $scope.device = deviceDetector;
    //$scope.isMobile = $scope.device.isMobile();

    $scope.disclaimerRDNBCA = false;
    $scope.disclaimerTAPRESBCA = false;

    $scope.filenameKTP = "";
    $scope.fileKTP = "";
    $scope.fileKTPext = "";
    $scope.KTPFile = [];

    $scope.filenameFotoDiri = "";
    $scope.fileFotoDiri = "";
    $scope.fileFotoDiriext = "";
    $scope.fotodiriFile = [];

    $scope.filenameTandaTangan = "";
    $scope.fileTandaTangan = "";
    $scope.fileTandaTanganext = "";
    $scope.tandatanganFile = [];

    $scope.finishSignature = false;
    $rootScope.myAppUtility = {
        isMobile: function isMobile() {
            return window && window.matchMedia("(max-width: 767px)").matches;
        }
    };

    $scope.openCamera = function (tipe) {
        if (!$rootScope.myAppUtility.isMobile()) {
            swal({
                title: 'Push notifications',
                text: 'Mohon untuk menggunakan kamera handphone',
                imageUrl: 'img/erdikha/from_erdikha/LoginSelamatDatang.png',
                imageAlt: 'E-KTP',
                width: '400px',
                animation: false
            });
            return;

        }
        let message = 'KTP';
        let url = 'ModalCamera.html';
        let ctrl = 'CameraController';



        //if ($scope.device.isMobile())
        //{
        //url = 'ModalBrowse.html';
        //ctrl = 'BrowseController';
        //$scope.append = 'data:image/png;base64,';
        //}

        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: url,
            controller: ctrl,
            size: 'md',
            resolve: {
                items: function () {
                    return message;
                }
            }
        });
        modalInstance.result.then(function (resolvedResponse) {
            //console.log('ktp',resolvedResponse);
            if (resolvedResponse) {
                if (tipe == "KTP")
                    $scope.ktpPhoto = resolvedResponse;
                else if (tipe == "SELFIE")
                    $scope.selfiePhoto = resolvedResponse;
                else
                    $scope.ttdPhoto = resolvedResponse;
            }
        }, function () { });
    };


    $scope.remove = function (tipe) {
        if (tipe == "TTD")
            $scope.ttdPhoto = '';
        else if (tipe == "SELFIE")
            $scope.selfiePhoto = '';
        else if (tipe == "KTP")
            $scope.ktpPhoto = '';
    };


    $scope.selectKTP = function (files) {
        $scope.KTPFile = files;
        let allowed = true;
        var reader = new FileReader();

        reader.onload = function (e) {
            if (allowed) {
                $scope.fileKTP = btoa(e.target.result.toString());
            }
        };
        console.log('gambar', $scope.KTPFile);
        reader.readAsBinaryString(files[0]);
        $scope.fileKTPext = files[0].name.substr(files[0].name.lastIndexOf('.'));
        console.log('gambar2', $scope.fileKTPext);

        if ($scope.allowedExt.indexOf($scope.fileKTPext.toLowerCase()) < 0) {
            allowed = false;
            $scope.fileKTPext = '';
            $scope.KTPFile = '';
            alert("Extensi yang dibolehkan : " + $scope.allowedExt);
        }
        else
            $scope.filenameKTP = files[0].name;
    };

    $scope.selectFotoDiri = function (files) {
        $scope.fotodiriFile = files;
        let allowed = true;
        var reader = new FileReader();

        reader.onload = function (e) {
            if (allowed) {
                $scope.fileFotoDiri = btoa(e.target.result.toString());
            }
        };

        reader.readAsBinaryString(files[0]);
        $scope.fileFotoDiriext = files[0].name.substr(files[0].name.lastIndexOf('.'));
        if ($scope.allowedExt.indexOf($scope.fileFotoDiriext.toLowerCase()) < 0) {
            allowed = false;
            $scope.fileFotoDiriext = '';
            $scope.fotodiriFile = '';
            alert("Extensi yang dibolehkan : " + $scope.allowedExt);
        }
        else
            $scope.filenameFotoDiri = files[0].name;
    };

    $scope.selectTandaTangan = function (files) {
        $scope.tandatanganFile = files;
        let allowed = true;
        var reader = new FileReader();

        reader.onload = function (e) {
            if (allowed) {
                $scope.fileTandaTangan = btoa(e.target.result.toString());
            }
        };

        reader.readAsBinaryString(files[0]);
        $scope.fileTandaTanganext = files[0].name.substr(files[0].name.lastIndexOf('.'));
        if ($scope.allowedExt.indexOf($scope.fileTandaTanganext.toLowerCase()) < 0) {
            allowed = false;
            $scope.fileTandaTanganext = '';
            $scope.tandatanganFile = '';
            alert("Extensi yang dibolehkan : " + $scope.allowedExt);
        }
        else
            $scope.filenameTandaTangan = files[0].name;
    };

    $scope.clickRemoveKTP = function (file, event, key) {
        event.preventDefault();
        $scope.fileKTP = "";
        $scope.filenameKTP = "";
        $scope.fileKTPext = "x";
        $scope.KTPFile.splice(key, 1);
        $scope.KTPFile = [];
        return null;
    };

    $scope.clickRemoveFotoDiri = function (file, event, key) {
        event.preventDefault();
        $scope.fileFotoDiri = "";
        $scope.filenameFotoDiri = "";
        $scope.fileFotoDiriext = "x";
        $scope.fotodiriFile.splice(key, 1);
        $scope.fotodiriFile = [];

        return null;
    };

    $scope.clickRemoveTandaTangan = function (file, event, key) {
        event.preventDefault();
        $scope.fileTandaTangan = "";
        $scope.filenameTandaTangan = "";
        $scope.fileTandaTanganext = "x";
        $scope.tandatanganFile.splice(key, 1);
        $scope.tandatanganFile = [];
        return null;
    };



    $scope.validateAgreement = function () {
        if ($scope.CIFInvestor.QuestionRDN == 1) {
            //if (!$scope.agree1 || !$scope.agree2 || !$scope.agree3) {
            //    $scope.disclaimerBank = false;
            //    swal('Error', 'Mohon klik PERNYATAAN NASABAH RDN BCA, KETENTUAN-KETENTUAN TAPRES PT BANK CENTRAL ASIA Tbk, SYARAT DAN KETENTUAN PT ERDIKHA ELIT SEKURITAS', 'error');
            //}

            //if ($scope.agree1 && !$scope.agree2 && !$scope.agree3) {
            //    $scope.disclaimerBank = false;
            //    swal('Error', 'Mohon klik KETENTUAN-KETENTUAN TAPRES PT BANK CENTRAL ASIA Tbk, SYARAT DAN KETENTUAN PT ERDIKHA ELIT SEKURITAS', 'error');
            //}

            //if ($scope.agree1 && $scope.agree2 && !$scope.agree3) {
            //    $scope.disclaimerBank = false;
            //    swal('Error', 'Mohon klik SYARAT DAN KETENTUAN PT ERDIKHA ELIT SEKURITAS', 'error');
            //}

            //if ($scope.agree1 && $scope.agree2 && $scope.agree3) {
            //    $scope.disclaimerBank = true;               
            //}

            if (!$scope.agree1 || !$scope.agree2) {
                $scope.disclaimerBank = false;
                swal('Error', 'Mohon klik PERNYATAAN NASABAH RDN BCA, KETENTUAN-KETENTUAN TAPRES PT BANK CENTRAL ASIA Tbk', 'error');
            }

            if (!$scope.agree1 && $scope.agree2) {
                $scope.disclaimerBank = false;
                swal('Error', 'Mohon klik PERNYATAAN NASABAH RDN BCA', 'error');
            }

            if ($scope.agree1 && !$scope.agree2) {
                $scope.disclaimerBank = false;
                swal('Error', 'Mohon klik KETENTUAN-KETENTUAN TAPRES PT BANK CENTRAL ASIA Tbk', 'error');
            }

            if ($scope.agree1 && $scope.agree2 && $scope.agree3) {
                $scope.disclaimerBank = true;
            }
        }
    }

    $scope.validateAgreementRDNBCA = function () {
        if ($scope.CIFInvestor.QuestionRDN == 1) {
            if (!$scope.agree1) {
                $scope.disclaimerRDNBCA = false;
                swal('Error', 'Mohon klik PERNYATAAN NASABAH RDN BCA PT BANK CENTRAL ASIA Tbk.', 'error');
            }
        }
    }

    $scope.validateAgreementTAPRESBCA = function () {
        if ($scope.CIFInvestor.QuestionRDN == 1) {
            if (!$scope.agree2) {
                $scope.disclaimerTAPRESBCA = false;
                swal('Error', 'Mohon klik PERNYATAAN KETENTUAN-KETENTUAN TAPRES PT BANK CENTRAL ASIA Tbk.', 'error');
            }
        }
    }

    $scope.validateAgreementPTMKES = function () {
        if ($scope.CIFInvestor.QuestionRDN == 1) {
            if (!$scope.agree3) {
                $scope.disclaimerPTMKES = false;
                swal('Error', 'Mohon klik Syarat dan Ketentuan PT ERDIKHA ELIT Sekuritas', 'error');
            }
        }
    }

    $scope.modalMessage = {
        message: '',
        param: {}
    };


    $scope.resetSign = function () {
        $rootScope.AlertYesNo('question', 'Konfirmasi', "Hapus Data Tanda Tangan?")
       .then((result) => {
           if (result.value) {
               $scope.finishSignature = false;
               $scope.filenameTandaTangan = '';
               $scope.appendttd = '';
               $scope.clear();
           }
       });
    };

    $scope.completeSign = function () {
        $scope.signature = $scope.accept();
        $scope.appendttd = '';
        if ($scope.signature.dataUrl && !$scope.signature.isEmpty) {
            $scope.finishSignature = true;
            $scope.CIFInvestor.TandaTanganFile = $scope.signature.dataUrl.substr($scope.signature.dataUrl.lastIndexOf(',') + 1);
            $scope.filenameTandaTangan = $scope.CIFInvestor.TandaTanganFile;
            $scope.appendttd = 'data:image/png;base64,';

            console.log('ttdfile', $scope.CIFInvestor.TandaTanganFile);
            console.log('filenamettd', $scope.filenameTandaTangan);
        }
        else
            $scope.filenameTandaTangan = '';
    };


    $scope.openModal = function () {
        var tempUrl = 'myModalContent.html';
        if ($scope.buttonText == "Save")
            tempUrl = 'myModalContentSementara.html';
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: tempUrl,
            controller: 'ModalInstanceCIFCtrl',
            size: 'md',
            resolve: {
                items: function () {
                    return $scope.modalMessage;
                }
            }
        });
    };

    $scope.showAgreement = function (number) {
        let htmlName = 'template/BCAagereement' + number + '.html';
        var modalInstance = $uibModal
        .open({
            animation: true,
            templateUrl: htmlName,
            controller: 'BCAAgreementCtrl',
            size: 'lg',
            backdrop: 'static',
            resolve: {
                agreementNumber: function () {
                    return number;
                }
            }
        });
        modalInstance.result.then(function (response, agree) {
            if (response == 'accept') {
                if (number == 1) {
                    $scope.agree1 = true;
                    $scope.disclaimerRDNBCA = true;
                }

                if (number == 2) {
                    $scope.agree2 = true;
                    $scope.disclaimerTAPRESBCA = true;
                }

                if (number == 3) {
                    $scope.agree3 = true;
                    $scope.disclaimerPTMKES = true;
                }

                if ($scope.disclaimerRDNBCA == true && $scope.disclaimerTAPRESBCA == true && $scope.disclaimerPTMKES == true) {
                    $scope.disclaimerBank = true;
                }

            }
        }, function () { });
    };

    var allPromise = $q.all([
        $http({
            method: 'POST',
            url: '/service/client.svc/retrieveSession',
        }).then(function (data) {
            if (!data.data.d) {
                $http({
                    method: 'GET',
                    url: '/service/client.svc/SignOut',
                }).then(function (data) {
                    if (data.data.d == true) {
                        $window.location.href = "#/login";
                        $window.location.reload();
                    }
                }, function (error) { })
            }
            else
                $scope.currentUser = data.data.d;
        }, function (error) { }),
    ]);



    allPromise.then(function () {
        $http({
            method: 'GET',
            url: '/service/client.svc/getCIF',
        }).then(function (data) {
            if (data.data.d != null) {
                var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;
                $scope.CIFInvestor.Stage = 4;
                $scope.filenameKTP = $scope.CIFInvestor.KTPFile;
                $scope.filenameFotoDiri = $scope.CIFInvestor.SelfieFile;
                //$scope.filenameTandaTangan = $scope.CIFInvestor.TandaTanganFile;

                if ($scope.filenameKTP) {

                    if (!$scope.filenameKTP.endsWith(".pdf")) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.filenameKTP,
                            responseType: 'blob',

                        }).then(function (response) {
                            if (response.data) {
                                var reader = new FileReader();
                                reader.readAsDataURL(response.data);
                                reader.onloadend = function () {
                                    $scope.ktpPhoto = reader.result;
                                    $scope.showKTP = false;
                                }

                            }
                            //$scope.KTPFile = [];
                            //$scope.KTPFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    }
                };
                if ($scope.filenameFotoDiri) {

                    if (!$scope.filenameFotoDiri.endsWith(".pdf")) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.filenameFotoDiri,
                            responseType: 'blob',
                        }).then(function (response) {
                            if (response.data) {
                                var reader2 = new FileReader();
                                reader2.readAsDataURL(response.data);
                                reader2.onloadend = function () {
                                    $scope.selfiePhoto = reader2.result;
                                }

                            }
                            //$scope.fotodiriFile = [];
                            //$scope.fotodiriFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    }
                };
                //if ($scope.filenameTandaTangan) {

                //    if (!$scope.filenameTandaTangan.endsWith(".pdf")) {
                //        $http({
                //            method: 'GET',
                //            url: 'FileKYC/' + $scope.filenameTandaTangan,
                //            responseType: 'blob',

                //        }).then(function (response) {
                //            if (response.data) {
                //                var reader3 = new FileReader();
                //                reader3.readAsDataURL(response.data);
                //                reader3.onloadend = function () {
                //                    $scope.ttdPhoto = reader3.result;
                //                }

                //            }
                //            //$scope.tandatanganFile = [];
                //            //$scope.tandatanganFile.push(response.data);
                //        }, function (response) {
                //            $scope.saveErrors = true;
                //            $scope.errorMessages = {
                //                text: 'File tidak ketemu atau terhapus dari server!!!',
                //            };
                //            $timeout(function () {
                //                $scope.saveErrors = false;
                //            }, 3000);
                //        });
                //    }
                //};

                if ($scope.CIFInvestor.TandaTanganFile) {
                    $http({
                        method: 'GET',
                        url: 'FileKYC/' + $scope.CIFInvestor.TandaTanganFile,
                        responseType: 'blob',

                    }).then(function (response) {
                        $scope.append = '';
                        let reader = new FileReader();
                        reader.readAsDataURL(response.data);
                        reader.onloadend = function () {
                            $scope.filenameTandaTangan = reader.result;
                        }
                        //$scope.tandatanganFile = [];
                        //$scope.tandatanganFile.push(response.data);
                    }, function (response) {
                        $scope.saveErrors = true;
                        $scope.errorMessages = {
                            text: 'File tidak ketemu atau terhapus dari server!!!',
                        };
                        $timeout(function () {
                            $scope.saveErrors = false;
                        }, 3000);
                    });
                };

                console.log('rdn', $scope.CIFInvestor.QuestionRDN);

                if ($scope.CIFInvestor.IsFinished == 1) {
                    $scope.disclaimerBank = true;
                    $scope.disclaimerRDNBCA = true;
                    $scope.disclaimerTAPRESBCA = true;
                    $scope.disclaimerPTMKES = true;
                }

                //swal({
                //    title: 'Upload Foto',
                //    text: 'Ketentuan untuk ambil gambar',
                //    imageUrl: 'img/erdikha/from_erdikha/uploadModal3.png',
                //    imageAlt: 'E-KTP',
                //    width: '900px',
                //    animation: false
                //});
            } // END IF data.data.d
        }, function (error) { });

    });

    $scope.submit = function () {
        if ($scope.ktpPhoto)
            $scope.CIFInvestor.KTPFile = $scope.ktpPhoto.replace("data:image/jpeg;base64,", "");

        if ($scope.selfiePhoto)
            $scope.CIFInvestor.SelfieFile = $scope.selfiePhoto.replace("data:image/jpeg;base64,", "");

        if ($scope.ttdPhoto)
            $scope.CIFInvestor.TandaTanganFile = $scope.ttdPhoto.replace("data:image/jpeg;base64,", "");

        $rootScope.AlertYesNo('question', 'Konfirmasi', "Apakah data yang diisi sudah sesuai?")
        .then((result) => {
            if (result.value) {
                $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);

                $http({
                    method: 'POST',
                    url: '/service/client.svc/SaveCIF',
                    data:
                        {
                            cifdata: $scope.CIFInvestor
                        },
                }).then(function (data) {
                    var respon = data.data.d;
                    if (respon.result) {
                        if ($scope.CIFInvestor.Stage == 4 && $scope.CIFInvestor.IsFinished == 0 || $scope.CIFInvestor.IsRevised == 1 && $scope.CIFInvestor.Stage == 4) {
                            swal('success', 'Dokumen Berhasil, Tahap Selanjutnya KYC Nasabah', 'success').then(function () {
                                $window.location.href = "#/cif/final";
                            });
                        }
                        else {
                            swal('success', 'Dokumen Berhasil, Tahap Selanjutnya KYC Nasabah', 'success').then(function () {
                                $scope.logOff();
                            });
                        }
                    }
                    else {
                        swal('Failed', data.data.d.message, 'error');
                    }
                }, function (error) {
                    swal('Error', 'error - Please check your connection', 'error');
                });
            }
        });

    }

    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: '/service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };

});